<template>
  <div class="workspace-layout theme-v3">
    <WorkspaceSidebar />
    <section class="workspace-content">
      <WorkspaceTopBar />
      <main class="workspace-main">
        <router-view />
      </main>
    </section>
  </div>
</template>

<script>
import WorkspaceSidebar from '@/components/workspace/WorkspaceSidebar.vue';
import WorkspaceTopBar from '@/components/workspace/WorkspaceTopBar.vue';

export default {
  name: 'WorkspaceLayout',
  components: { WorkspaceSidebar, WorkspaceTopBar }
};
</script>

<style lang="less" scoped>
.workspace-layout {
  display: flex;
  min-height: 100vh;
  background: var(--bg);
}
.workspace-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.workspace-main {
  flex: 1;
  padding: 28px;
  overflow-y: auto;
}
</style>
